export default {
    info: 'ព័ត៌មានផ្ទាល់ខ្លួន',
    first_name: 'ឈ្មោះ',
    last_name: 'ត្រកូល',
    full_name: 'ឈ្មោះ​ពេញ',
    country: 'ប្រទេស',
    email: 'អ៊ីមែល',
    username: 'ឈ្មោះ​អ្នកប្រើ',
    phone: 'លេខទូរស័ព្ទ',
    address: 'អាស័យដ្ឋាន',
    postal_code: 'លេខ​កូដ​ប្រៃ​ស​ណី​យ៏',
    account: 'ព័ត៌មាន​គណនី',
    change_password: 'ផ្លាស់ប្តូរពាក្យសម្ងាត់',
    change_pass_current: 'ពាក្យសម្ងាត់​ចាស់',
    change_pass_new: 'ពាក្យសម្ងាត់​ថ្មី',
    change_pass_confirm: 'បញ្ជាក់ពាក្យសម្ងាត់',
    edit_save: 'រក្សាទុក',
    edit_cancel: 'បោះបង់',
    my_profile: 'ប្រវត្តិរូប',
    city: 'ទីក្រុង',
    province: 'ខេត្ត/រដ្ឋ',
    zip_code: 'លេខកូដប្រៃសណីយ៍/តំបន់',
    email_verification: 'ផ្ទៀងផ្ទាត់អ៊ីមែល',
    company_name_KH: {
        en: 'ឈ្មោះក្រុមហ៊ុន (EN)',
        km: 'ឈ្មោះក្រុមហ៊ុន (KH)',
    },
    address_KH: {
        en: 'អាសយដ្ឋាន (EN)',
        km: 'អាសយដ្ឋាន (KH)',
    },
    vat_tin: {
        KH: 'VAT TIN',
        AE: 'TRN',
    },
    representative_en: 'ឈ្មោះតំណាង',
    signature: 'ហត្ថលេខា',
    signature_hint: 'យើងគាំទ្រ PNG, JPG, JPEG, អតិបរមា {value}/file',
    company_info: 'ព័ត៌មានក្រុមហ៊ុន',
    change_email: 'ផ្លាស់ប្តូរអ៊ីមែល',
    current_email: 'អ៊ីមែលបច្ចុប្បន្ន',
    new_email: 'អ៊ីមែលថ្មី',
    your_password: 'ពាក្យសម្ងាត់របស់អ្នក',
    otp_hint: 'OTP នឹងត្រូវបានផ្ញើទៅកាន់អាសយដ្ឋានអ៊ីមែលបច្ចុប្បន្នរបស់អ្នក',
    google_account: {
        title: 'គណនី Google',
        link_account: 'ភ្ជាប់គណនី Google',
        unlink_account: 'ផ្តាច់',
        unlink_confirm_action:
            'តើអ្នកប្រាកដថាចង់ផ្តាច់គណនី Google របស់អ្នកមែនទេ?',
    },
};
